const Gray = {
  100: '#FFFFFF',
  150: '#F6F6F6',
  200: '#F7F7F7',
  250: '#E5E5E5',
  300: '#999999',
  350: '#767676',
  400: '#666666',
  500: '#21252E',
};

const Purple = {
  100: '#E9CFFF',
  300: '#8B21E3',
  400: '#6E13B9',
  500: '#4C0192',
};

const Green = {
  100: '#BFF4C4',
  200: '#12B76A',
  300: '#309E3A',
  400: '#039855',
};

const White = {
  100: '#FFFFFF',
};

const Black = {
  100: '#292929',
};

const Red = {
  300: '#F04438',
  500: '#B42318',
};

const Blue = {
  300: '#6AB8F7',
};

const Orange = {
  100: '#FFFAEB',
  300: '#F79009',
  400: '#DC6803',
};

export {
  Gray,
  Purple,
  Green,
  White,
  Black,
  Red,
  Blue,
  Orange,
};
